import { Controller } from "@hotwired/stimulus";
import { saveAs } from 'file-saver';

export default class TableController extends Controller {
    static targets = [];
    static values = {
        csvContent: String
    };

    readonly csvContentValue!: string;

    downloadCsv() {
        const blob = new Blob([this.csvContentValue], { type: "text/csv;charset=utf-8" });
        saveAs(blob, 'table.csv');
    }
}
